import React from 'react';

import { AccountNumbersProvider } from '@atlas/core';
import { HeaderTitle, Label } from '@atlas/ui';

import StaticBlock from 'src/common/StaticBlock/StaticBlock';

import AccountNumbersForm from './AccountNumbersForm';

const AccountNumbers = () => {
  return (
    <div className="account-numbers">
      <div className="title-wrapper">
        <HeaderTitle title="account_numbers_enter_account_numbers" />
        <Label
          className="description title-small-300-text"
          message="account_numbers_important_message"
        />
        <Label
          className="description title-small-300-text"
          message="account_numbers_important_info"
        />
      </div>
      <AccountNumbersProvider>
        <AccountNumbersForm />
      </AccountNumbersProvider>
      <StaticBlock
        className="account-numbers-static-block"
        options={{ source: 'account-numbers-content' }}
      />
    </div>
  );
};

export default AccountNumbers;
